import {Word} from "../../../common/types/words";
import {DutchConjugationView} from "../languages/dutch/components/DutchConjugationView";
import {JapaneseConjugationView} from "../languages/japanese/components/JapaneseConjugationView";

export interface ConjugationViewProps {
    word: Word
    language: string
}

export function ConjugationView({word, language}: ConjugationViewProps) {

    if (language === "Dutch") {
        return <DutchConjugationView word={word} language={language} />
    }

    if (language === "Japanese") {
        return <JapaneseConjugationView word={word} language={language} />
    }

    return null;

}